import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { calculateWinner } from "../lib/calculateWinner";
import { resetFilledLines } from "../lib/resetFilledLines";
import useScoreStore from "../lib/stores/scoreStore";
import useTicTacToeStore from "../lib/stores/ticTacToesStore";
import Score from "./Score";
import Square from "./Square";
const Board = () => {
    const { isXNext, moveOrder, gameMode, squares, setIsXNext, setMoveOrder, setSquares, handleNextStarter, } = useTicTacToeStore();
    const { increaseScore, restartScore } = useScoreStore();
    const handleMoveOrder = (newSquares, player) => {
        if (moveOrder.length === 7) {
            const indexToRemove = moveOrder.findIndex((ind) => squares[ind] === player);
            if (indexToRemove !== -1) {
                newSquares[moveOrder[indexToRemove]] = null;
                moveOrder.splice(indexToRemove, 1);
                setSquares(newSquares);
            }
        }
        else
            setSquares(newSquares);
    };
    const handleGameModes = (newSquares, player, index) => {
        if (gameMode === "resetMode")
            setSquares(resetFilledLines(newSquares));
        else {
            moveOrder.push(index);
            handleMoveOrder(newSquares, player);
        }
    };
    const handleSquareClick = (index) => {
        if (squares[index])
            return;
        const newSquares = [...squares];
        const currentPlayer = isXNext ? "X" : "O";
        newSquares[index] = currentPlayer;
        handleGameModes(newSquares, currentPlayer, index);
        setIsXNext(!isXNext);
        if (calculateWinner(newSquares))
            handleReset(currentPlayer);
    };
    const handleReset = (player) => {
        if (player)
            increaseScore(player);
        setSquares(Array(9).fill(null));
        setMoveOrder([]);
        setIsXNext(true);
        handleNextStarter();
    };
    return (_jsxs("div", { className: "flex flex-col items-start gap-6", children: [_jsx("div", { className: "flex w-full justify-end", children: _jsx("button", { onClick: () => handleReset(), className: "text-2xl font-bold", children: "Reset Game" }) }), _jsx("div", { className: "grid grid-cols-3 gap-3", children: squares.map((value, index) => (_jsx(Square, { value: value, onClick: () => handleSquareClick(index) }, index))) }), _jsxs("div", { className: "flex w-full justify-between", children: [_jsx(Score, {}), _jsx("button", { onClick: restartScore, className: "text-2xl font-bold", children: "Reset Score" })] })] }));
};
export default Board;
